export default __webpack_public_path__ + "static/media/JOSA SYLLABUS_2026-27 CLASS 8.3a064cb8.pdf";